<div class="login-register"
    style="background: url(assets/images/background/notebook-1280538_1920.jpg) no-repeat center center fixed; background-size: cover;">
</div>
<div class="login-container" fxLayout="column">
    <vzn-login [authService]="authService" (authSuccess)="authSuccess($event)" [loginBy]="loginState"></vzn-login>
    <div>
        <button mat-button (click)="toggleLoginState()">{{ loginStateChangeText }}</button>
    </div>
</div>